import { Component, HostBinding, inject, input, ChangeDetectionStrategy } from "@angular/core";
import { DialogAdapter } from "common/dialog/dialog-adapter";
import { NgTemplateOutlet } from "@angular/common";
import { ButtonExpandCollapseComponent } from "common/buttons/button-expand-collapse.component";
import { ButtonsBottomComponent } from "common/buttons/buttons-bottom.component";
import { TranslateModule } from "@ngx-translate/core";

export class MessageDetails {
	header: string = "";
	list: string[] = [];
}

@Component({
	selector: "stages-warn",
	templateUrl: "./warn.component.html",
	styleUrls: ["./warn.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [NgTemplateOutlet, ButtonExpandCollapseComponent, ButtonsBottomComponent, TranslateModule],
})
export class WarnComponent {
	private dialog = inject(DialogAdapter);

	@HostBinding("class.confirm") customClass = true;

	messageDetailsExpanded = true;

	readonly keys = input.required<{
		title?: string;
		message: string;
		messageDetails?: MessageDetails;
		ok: string;
	}>();

	ok(): void {
		this.dialog.close("ok");
	}

	toggleList(): void {
		this.messageDetailsExpanded = !this.messageDetailsExpanded;
	}
}
